import React from 'react';
import styles from './Footer.module.css';
import { LINKS } from '../../config/links';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <a className={styles.support} href={LINKS.support} target="_blank" rel="noopener noreferrer">
        🤝 Поддержка
      </a>
      <p className={styles.devs}>
        <span className={styles.devsLabel}>Разработчики</span>
        <span className={styles.devNames}>
          <span className={styles.devName}>Роман Якименко</span>
          <span className={styles.devSep} aria-hidden="true">и</span>
          <span className={styles.devName}>Вероника Якименко</span>
        </span>
      </p>
      <span className={styles.copy}>© {new Date().getFullYear()} Voice Cut</span>
    </footer>
  );
}
